function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M17 2a3 3 0 0 1 3 3v16a1 1 0 0 1-1.555.832L12 18.202l-6.445 3.63A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3zm0 2H7a1 1 0 0 0-1 1v14.131l5.445-2.963a1 1 0 0 1 1.11 0L18 19.13V5a1 1 0 0 0-1-1m-4.794 4.048c.091.045.165.12.21.211l.676 1.369 1.51.22a.464.464 0 0 1 .258.791l-1.093 1.066.258 1.504a.464.464 0 0 1-.674.49l-1.135-.597a.46.46 0 0 0-.432 0l-1.135.596a.464.464 0 0 1-.674-.49l.258-1.503-1.093-1.066a.464.464 0 0 1 .258-.792l1.51-.22.676-1.368a.464.464 0 0 1 .622-.21z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-favorite-outline.svg";
export { SvgComponent as ReactComponent };